import React, { useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { getBuyerPOByDocNo } from "../services/api/buyerPO";
import { getSellerPOByDocNum } from '../services/api/sellerPO';
import { getBuyerQuoteByDocNo } from '../services/api/buyerQuote';
import { getAdjustmentNoteByDocNo } from '../services/api/adjustmentNotes';
import { getBuyerInvoiceByDocNo } from '../services/api/buyerInvoice';
import { getPettyCashByVoucherNo } from '../services/api/pettyCash';
import { getDeliveryChallanByDocNo } from '../services/api/deliveryChallan';
import { getProformaInvoiceByDocNo } from '../services/api/proformaInvoice';
import { getVendorPaymentByDocNo } from '../services/api/vendorPayment';
import { getSellerPIPunchByDocNo } from '../services/api/sellerPIPunch';
import { getSellerGRNQCPunchByDocNo } from '../services/api/sellerGRNQCPunch';

import { raiseToast } from '../services/redux/reducers/toast/toast';


const DocRedirect = () => {
	const location = useLocation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	useEffect(() => {
		getRelatedDoc()

	}, [])

	const getRelatedDoc = async () => {
		const docNo = location.pathname.replace('/docs/', '');
		if (docNo) {
			const docTypeId = docNo.substring(0, 2);

			if (docTypeId === '11') {
				navigate(`/requirement?docNo=${docNo}`)
			}
			else if (docTypeId === '12') {
				navigate(`/requirement?docNo=${docNo}`)
			} else if (docTypeId === '14') {
				let relatedBuyerPO = await getBuyerPOByDocNo(docNo)
				if (relatedBuyerPO?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Buyer PO", detail: relatedBuyerPO?.error, life: 3000 }))
				} else {
					relatedBuyerPO = relatedBuyerPO?.data
					if (relatedBuyerPO) {
						navigate(`/buyerpo/${relatedBuyerPO?.buyerPOId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}

			} else if (docTypeId === '15') {
				let relatedSellerPO = await getSellerPOByDocNum(docNo)
				if (relatedSellerPO?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Seller PO", detail: relatedSellerPO?.error, life: 3000 }))
				} else {
					relatedSellerPO = relatedSellerPO?.data
					if (relatedSellerPO) {
						navigate(`/sellerpo/${relatedSellerPO?.sellerPOId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}

			} else if (docTypeId === '13') {
				let relatedBuyerQuote = await getBuyerQuoteByDocNo(docNo)
				if (relatedBuyerQuote?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Buyer Quote", detail: relatedBuyerQuote?.error, life: 3000 }))
				} else {
					relatedBuyerQuote = relatedBuyerQuote?.data
					if (relatedBuyerQuote) {
						navigate(`/buyer/quotation/${relatedBuyerQuote?.buyerQuoteId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			} else if (docTypeId === '18' || docTypeId === '21' || docTypeId === '22') {
				let relatedAdjustmentNote = await getAdjustmentNoteByDocNo(docNo)
				if (relatedAdjustmentNote?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Adjustment Note", detail: relatedAdjustmentNote?.error, life: 3000 }))
				} else {
					relatedAdjustmentNote = relatedAdjustmentNote?.data?.adjustmentNote
					if (relatedAdjustmentNote) {
						if (docTypeId === '18') {
							navigate(`/debitnote/${relatedAdjustmentNote?.adjustmentNoteId}`)
						}
						else if (docTypeId === '21') {
							navigate(`/credit_note/${relatedAdjustmentNote?.adjustmentNoteId}`)
						}
						else if (docTypeId === '22') {
							navigate(`/buyer-debit-note/${relatedAdjustmentNote?.adjustmentNoteId}`)
						}
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			}
			else if (docTypeId === '20' || docTypeId === '23') {
				let relatedBuyerInvoice = await getBuyerInvoiceByDocNo(docNo)
				if (relatedBuyerInvoice?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Buyer Invoice", detail: relatedBuyerInvoice?.error, life: 3000 }))
				} else {
					relatedBuyerInvoice = relatedBuyerInvoice?.data
					if (relatedBuyerInvoice) {
						navigate(`/buyerInvoice/${relatedBuyerInvoice?.buyerInvoiceId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available', life: 3000 }))
					}
				}
			}
			else if (docTypeId === '24') {
				navigate(`/pettycash?transactionNo=${docNo}`)
			}
			else if (docTypeId === '25') {
				let relatedPettyCashVoucher = await getPettyCashByVoucherNo(docNo)
				if (relatedPettyCashVoucher?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "PettyCash Voucher", detail: relatedPettyCashVoucher?.error, life: 3000 }))
				} else {
					if (relatedPettyCashVoucher) {
						navigate(`/voucher/${relatedPettyCashVoucher?.pettyCashId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			}
			else if (docTypeId === '29') {
				let relatedDeliveryChallan = await getDeliveryChallanByDocNo(docNo)
				if (relatedDeliveryChallan?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Delivery Challan", detail: relatedDeliveryChallan?.error, life: 3000 }))
				} else {
					relatedDeliveryChallan = relatedDeliveryChallan?.data
					if (relatedDeliveryChallan) {
						navigate(`/delivery_challan/${relatedDeliveryChallan?.deliveryChallanId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			}
			else if (docTypeId === '32') {
				let relatedProformaInvoice = await getProformaInvoiceByDocNo(docNo)
				if (relatedProformaInvoice?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Proforma Invoice", detail: relatedProformaInvoice?.error, life: 3000 }))
				} else {
					relatedProformaInvoice = relatedProformaInvoice?.data
					if (relatedProformaInvoice) {
						navigate(`/proforma_invoice/${relatedProformaInvoice?.proformaInvoiceId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			}
			else if (docTypeId === '19') {
				let relatedVendorPayment = await getVendorPaymentByDocNo(docNo)
				if (relatedVendorPayment?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Vendor Payment", detail: relatedVendorPayment?.error, life: 3000 }))
				} else {
					relatedVendorPayment = relatedVendorPayment?.data
					if (relatedVendorPayment?.sellerPOId) {
						navigate(`/vendor_payment_summary/${relatedVendorPayment?.sellerPOId}`)
					}
					else if (relatedVendorPayment?.pettyCashId) {
						navigate(`/pettycash?pettyCashId=${relatedVendorPayment?.pettyCashId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			}
			else if (docTypeId === '16') {
				let relatedSellerPIPunch = await getSellerPIPunchByDocNo(docNo)
				if (relatedSellerPIPunch?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Seller PIPunch", detail: relatedSellerPIPunch?.error, life: 3000 }))
				} else {
					relatedSellerPIPunch = relatedSellerPIPunch?.data
					if (relatedSellerPIPunch) {
						navigate(`/sellerpo/${relatedSellerPIPunch?.sellerPOId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			}
			else if (docTypeId === '17') {
				let relatedSellerGRNQCPunch = await getSellerGRNQCPunchByDocNo(docNo)
				if (relatedSellerGRNQCPunch?.failure) {
					return dispatch(raiseToast({ severity: 'error', summary: "Seller GRNQCPunch", detail: relatedSellerGRNQCPunch?.error, life: 3000 }))
				} else {
					relatedSellerGRNQCPunch = relatedSellerGRNQCPunch?.data
					if (relatedSellerGRNQCPunch) {
						navigate(`/sellerpo/${relatedSellerGRNQCPunch?.sellerPOId}`)
					}
					else {
						return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
					}
				}
			}
			else {
				return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Document Number entered is either invalid or not available.', life: 3000 }))
			}
		} else {
			return dispatch(raiseToast({ severity: 'error', summary: "Document", detail: 'Please enter docNo', life: 3000 }))

		}
	}

	return (
		<div>
		</div>
	)
}

export default DocRedirect;
